/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import StoreContext from './StoreContext';
import { SlingHeader, Grid, Cell } from './base/styled';

import './DashboardIndex.scss';

const DashboardIndex = ({ params, history }) => {

  const categories = [];
  const dashboardsByCategory = {};

  params.forEach((entry) => {
    if (!entry.metadata.hide) {
      const category = entry.metadata.category;
      if (!categories.includes(category)) {
        categories.push(category);
        dashboardsByCategory[category] = [];
      }
      dashboardsByCategory[category].push(entry);
    }
  });

  const doLogout = async (store) => {
    const response = await fetch(
      '/sys/logout',
      {
        method: 'GET',
        credentials: 'include',
      },
    );
    if (response) {
      const json = await response.json();
      if (!json.error) {
        const { dashboards } = json;
        store.setCredentials(null, dashboards);
        history.push('/');
      }
    }
  };

  return (
    <StoreContext.Consumer>
      {store => (
        <div className="DashboardIndex">
          <div className="wideband">
            <div className="left">
              {store.user
                ? (
                  <span>
                    You are logged in as:&nbsp;&nbsp;&nbsp;
                    <span style={{ textDecoration: 'underline' }}>
                      {store.user.username}
                    </span>
                  </span>)
                : ''
              }
            </div>
            {!store.user || (store.user && !store.user.viaProxy) ? (
              <div className="right">
                {store.user //eslint-disable-line no-nested-ternary
                  ? (
                    store.user.viaProxy ? (<div />) : (
                      <span
                        role="button"
                        tabIndex={0}
                        className="link"
                        onClick={() => {
                          doLogout(store);
                        }}
                        onKeyDown={() => {
                          doLogout(store);
                        }}
                      >
                      SIGN OUT
                      </span>
                    )
                  ) : <Link className="link" to="/login">SIGN IN</Link>
                }
              </div>
            ) : <div /> }
          </div>
          <SlingHeader title="A La Carte Dashboards" />
          { categories.length >= 3 ? (
            <nav className="navbar">
              <div className="nav-items">
                {
                  categories.map(category => (
                    <div className="nav-item" key={`scroll-${category.replace(' ', '-')}`}>
                      <ScrollLink
                        activeClass="active"
                        to={category.replace(' ', '_')}
                        smooth
                        offset={10}
                        duration={500}
                      >
                        {category}
                      </ScrollLink>
                    </div>
                  ))
                }
                <div className="padding" />
              </div>
            </nav>
          ) : (<div />)}
          <div className="main">
            {
              categories.map(category => (
                <div className="category" key={category} id={category.replace(' ', '_')}>
                  <h2 className="categoryLabel">{ category }</h2>
                  <Grid
                    columns="repeat(auto-fit,minmax(400px,1fr))"
                    justifyContent="start"
                    height="inherit"
                  >
                    {
                      dashboardsByCategory[category].map(entry => (
                        <Cell className="cell" key={entry.path}>
                          <div className="linkwrapper">
                            <Link
                              className="link"
                              to={entry.path}
                            >
                              <div className="title">{entry.metadata.title}</div>
                              <img alt={entry.metadata.title} src={'/api/thumbnail/' + (entry.localProps && entry.localProps.panes ? entry.localProps.panes[0] : entry.path)} />
                              <div className="description">
                                { entry.metadata.description || '' }
                              </div>
                            </Link>
                          </div>
                        </Cell>
                      ))
                    }
                  </Grid>
                </div>
              ))
            }
          </div>
          <div className="wideband">
            <div className="right">
              {store.user ? (<Link className="link" to="/jql-console">JIRA JQL CONSOLE</Link>) : (<div />)}
              {store.user ? (<Link className="link" to="/log">SERVER LOGS</Link>) : (<div />)}
            </div>
          </div>
        </div>)
      }
    </StoreContext.Consumer>
  );
};

DashboardIndex.propTypes = {
  params: PropTypes.arrayOf(PropTypes.shape({
    path: PropTypes.string.isRequired,
    component: PropTypes.string.isRequired,
    title: PropTypes.string,
  })).isRequired,
  history: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default DashboardIndex;
